import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import axios from '@axios'

export const getInitialState = () => ({
  ...storePagination.state(),
  sorting: {
    sortBy: 'id',
    sortDesc: true,
  },
  approvalGroups: [],
  filters: {
    name: '',
    userId: null,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_APPROVAL_GROUPS(state, approvalGroups) {
      state.approvalGroups = approvalGroups
    },

    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const defaultData = getInitialState()
      Object.keys(defaultData).forEach(key => {
        state[key] = defaultData[key]
      })
    },
    CLEAN_PAGING(state) {
      state.paging = getInitialState().paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchApprovalGroups({ state, commit }) {
      const { name, userId } = state.filters

      const { data } = await axios.get('/api/approval-groups', {
        params: {
          name,
          userId,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_APPROVAL_GROUPS', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },

    resetFilters({ commit }) {
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
    cleanPaging({ commit }) {
      commit('CLEAN_PAGING')
    },
  },
}
